import {
  useAppSelector,
  mapSelector,
} from '../../../store';

import './Featured.scss';

export default function Featured() {
  const iMap = useAppSelector(mapSelector);

  return (
    <>
      { iMap.featured_image && (
        <section className="sidebar-image">
          <img
            src={iMap.featured_image.thumb || iMap.featured_image.base64}
            alt="featured"
          />
        </section>
      )}
      { iMap.featured_video && (
        <section className="sidebar-video">
          <iframe
            src={iMap.featured_video}
            frameBorder="0"
            // @ts-ignore TS2322
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            allow="fullscreen"
            title="featured video"
          />
        </section>
      )}
    </>
  );
}
